var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCanRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-can-regular 1",
    clipPath: "url(#clip0_173_9659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99414 1.81406L5.32617 2.8125H10.4238L9.75586 1.81406C9.70312 1.73672 9.61523 1.6875 9.52031 1.6875H6.22617C6.13125 1.6875 6.04336 1.7332 5.99062 1.81406H5.99414ZM11.1621 0.878906L12.4523 2.8125H12.9375H14.625H14.9062C15.3738 2.8125 15.75 3.18867 15.75 3.65625C15.75 4.12383 15.3738 4.5 14.9062 4.5H14.625V15.1875C14.625 16.7414 13.3664 18 11.8125 18H3.9375C2.38359 18 1.125 16.7414 1.125 15.1875V4.5H0.84375C0.376172 4.5 0 4.12383 0 3.65625C0 3.18867 0.376172 2.8125 0.84375 2.8125H1.125H2.8125H3.29766L4.58789 0.875391C4.95352 0.330469 5.56875 0 6.22617 0H9.52031C10.1777 0 10.793 0.330469 11.1586 0.875391L11.1621 0.878906ZM2.8125 4.5V15.1875C2.8125 15.8098 3.31523 16.3125 3.9375 16.3125H11.8125C12.4348 16.3125 12.9375 15.8098 12.9375 15.1875V4.5H2.8125ZM5.625 6.75V14.0625C5.625 14.3719 5.37187 14.625 5.0625 14.625C4.75313 14.625 4.5 14.3719 4.5 14.0625V6.75C4.5 6.44063 4.75313 6.1875 5.0625 6.1875C5.37187 6.1875 5.625 6.44063 5.625 6.75ZM8.4375 6.75V14.0625C8.4375 14.3719 8.18437 14.625 7.875 14.625C7.56563 14.625 7.3125 14.3719 7.3125 14.0625V6.75C7.3125 6.44063 7.56563 6.1875 7.875 6.1875C8.18437 6.1875 8.4375 6.44063 8.4375 6.75ZM11.25 6.75V14.0625C11.25 14.3719 10.9969 14.625 10.6875 14.625C10.3781 14.625 10.125 14.3719 10.125 14.0625V6.75C10.125 6.44063 10.3781 6.1875 10.6875 6.1875C10.9969 6.1875 11.25 6.44063 11.25 6.75Z",
    fill: "#F58B7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_9659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanRegular);
export default __webpack_public_path__ + "static/media/trash-can-regular.d32b4a3e7a0943b0b17baaa78ddd9f86.svg";
export { ForwardRef as ReactComponent };